<template>
  <div>
    <div class="tit-box type1">
      <h1 class="tit-type1">시설기본정보</h1>
    </div>
    <table class="tb-row">
      <colgroup>
        <col style="width:18%;"/>
        <col style="width:auto;"/>
        <col style="width:18%;"/>
        <col style="width:auto;"/>
      </colgroup>
      <tbody>
      <tr>
        <th>대표자명</th>
        <td>{{ rpstvNm }}</td>
        <th>대표자 주민번호</th>
        <td class="last">
          <number-ip :data="rpstvIirno1"
                     :width="'100px'"
                     :maxlength="6"
                     @input="ipRpstvIirno1_input"/> -
          <number-ip :data="rpstvIirno2"
                     :width="'100px'"
                     :maxlength="7"
                     @input="ipRpstvIirno2_input"/>
        </td>
      </tr>
      <tr>
        <th>개업일</th>
        <td colspan="3"
            class="last">
          <cal :date="opbzDe"
               @select="opbzDe_select"
               style="width: 150px;"/>
        </td>
      </tr>
      </tbody>
    </table>
    <div class="tit-box type1 mgt20">
      <h1 class="tit-type1">업무담당자정보</h1>
    </div>
    <table class="tb-row">
      <colgroup>
        <col style="width:18%;"/>
        <col style="width:auto;"/>
        <col style="width:18%;"/>
        <col style="width:auto;"/>
      </colgroup>
      <tbody>
      <tr>
        <th>담당자명</th>
        <td>
          <input type="text"
                 class="txt"
                 maxlength="20"
                 style="width:150px;"
                 v-model="chrgrNm"/>
        </td>
        <th>담당자연락처</th>
        <td class="last">
          <select style="width: 70px;"
                  v-model="chrgrCtpc1">
            <option value="">선택</option>
            <option v-for="tlno in $cmmn.txt.mbpns"
                    :key="'tlno-' + tlno"
                    :value="tlno"> {{ tlno }}</option>
          </select> -
          <number-ip :data="chrgrCtpc2"
                     :width="'100px'"
                     :maxlength="4"
                     @input="chrgrCtpc2_input"/> -
          <number-ip :data="chrgrCtpc3"
                     :width="'100px'"
                     :maxlength="4"
                     @input="chrgrCtpc3_input"/>
        </td>
      </tr>
      </tbody>
    </table>
    <div class="tit-box type1 mgt20">
      <h1 class="tit-type1">환급계좌정보</h1>
    </div>
    <table class="tb-row">
      <colgroup>
        <col style="width:18%;"/>
        <col style="width:auto;"/>
        <col style="width:18%;"/>
        <col style="width:auto;"/>
      </colgroup>
      <tbody>
      <tr>
        <th>환급은행</th>
        <td>
          <cd-selbx :cds="bnks"
                    :cd="rtunBnkCd"
                    :is-select="true"
                    :width="'300px'"
                    @select="selbxRtunBnkCd_select"/>
        </td>
        <th>예금주</th>
        <td class="last">
          <input type="text"
                 class="txt"
                 maxlength="20"
                 style="width:150px;"
                 v-model="rtunDpstr"/>
        </td>
      </tr>
      <tr>
        <th>환급계좌번호</th>
        <td colspan="3" class="last">
          <number-ip :data="rtunCcno"
                     :maxlength="20"
                     :width="'300px'"
                     @input="ipRtunCcno_input"/>
        </td>
      </tr>
      </tbody>
    </table>
    <div style="display: flex;">
      <div style="flex: 1;">
        <div class="tit-box type1 mgt20">
          <h1 class="tit-type1">시설직인</h1>
          <div>
            <btn class="mgr10"
                 :txt="'등록'"
                 @click="btnFcltyOfslRgst_click"/>
            <single-file-upload
                :is-btn-show="false"
                ref="fcltyOfslFileUpldRef"
                :se="'tmp'"
                :accepts="'jpg,jpeg,png,bmp'"
                :is-resize-img="true"
                @change="fcltyOfslFileUpld_change"/>
          </div>
        </div>
        <img v-if="!fcltyOfslSrc"
             src="@/assets/img/common/no-img.png"
             style="width: 70px;"/>
        <img v-if="fcltyOfslSrc"
             :src="fcltyOfslSrc"
             style="width: 70px;"/>
        <div>
          <span class="material-icons-round pc01 md-16 pd5">mode_comment</span> 업로드 가능한 확장자는 gif, png, jpg, jpeg, bmp, pdf 입니다. <br /> (최대 파일 크기 : 10MB)
        </div>
      </div>
      <div style="flex: 1;">
        <div class="tit-box type1 mgt20">
          <h1 class="tit-type1">과거 세무신고자료 간편 제출</h1>
        </div>
        <div class="submit-desc">당해 연도에 신고한 원천세 신고자료의 오류검증을 위해 과거 신고자료를 제출합니다.</div>
        <div class="submit-method">
          <div class="method-item">
            <span class="method-label">방법1)</span>
            <button class="small bt-blue" @click="btnSmplPrsnt_click"><span>간편 제출하기</span></button>
            <div class="method-desc">인증서로 조회하여 제출하는 방법입니다.<b>(인증서는 별도로 저장되지 않습니다.)</b></div>
          </div>
          <div class="method-item">
            <span class="method-label">방법2)</span>
            <button class="small bt-blue" @click="btnPdfPrsnt_click"><span>직접 제출하기</span></button>
            <div class="method-desc">홈택스에서 pdf 파일로 다운로드하여 제출하는 방법입니다.</div>
          </div>
        </div>
        <div>{{cprCrct.certname}}</div>
      </div>
    </div>
  </div>
  <div class="layer-btn">
    <btn :txt="'취소'"
         @click="btnCancl_click"/>
    <btn :txt="'요청'"
         :color="'purple'"
         @click="btnRqt_click"/>
  </div>
</template>

<script setup>
import { initSmartaib4pc, loadSmartaib4pcScript } from "@/utils/smartaib4pc";
import {computed, defineEmits, defineProps, onMounted, reactive, ref} from "vue";
import {getStore, getUtils} from "@/utils/import";
import StmnSmplPrsntCnfm from "@/views/my-home/stmn-smpl-prsnt-cnfm.vue";
import StmnPdfPrsntCnfm from "@/views/my-home/stmn-pdf-prsnt-cnfm.vue";
import StmnPdfUpload from "@/views/my-home/stmn-pdf-upload.vue";
import StmnAgncyCnsgRqtCompt from "@/views/my-home/stmn-agncy-cnsg-rqt-compt.vue"

const {$cmmn, $cd, $alert, $valid, $file, $axios, $popup} = getUtils();
const {$loading, $mber} = getStore();

const props = defineProps({
  fcltySn: Number
});

const fcltySn = computed(() => props.fcltySn);

const pdfFiles = ref([]);

const rpstvNm = ref('');
const rpstvIirno = computed(() => rpstvIirno1.value + '' + rpstvIirno2.value);
const rpstvIirno1 = ref('');
const rpstvIirno2 = ref('');
const opbzDe = ref('');

const ipRpstvIirno1_input = (data) => {
  rpstvIirno1.value = data;
}

const ipRpstvIirno2_input = (data) => {
  rpstvIirno2.value = data;
}

const opbzDe_select = (date) => {
  opbzDe.value = date;
}

const chrgrNm = ref('');
const chrgrCtpc = computed(() => chrgrCtpc1.value + '-' + chrgrCtpc2.value + '-' + chrgrCtpc3.value);
const chrgrCtpc1 = ref('010');
const chrgrCtpc2 = ref('');
const chrgrCtpc3 = ref('');

const chrgrCtpc2_input = (data) => {
  chrgrCtpc2.value = data;
}

const chrgrCtpc3_input = (data) => {
  chrgrCtpc3.value = data;
}

const bnks = ref([]);
const rtunBnkCd = ref('');
const rtunDpstr = ref('');
const rtunCcno = ref('');
const selbxRtunBnkCd_select = (data) => {
  rtunBnkCd.value = data;
}

const ipRtunCcno_input = (data) => {
  rtunCcno.value = data;
}

const fcltyOfslFileUpldRef = ref(null);

const fcltyOfslSrc = ref('');
const fcltyOfslFile = reactive({
  orgnFlnm: null,
  strePth: null,
  flnm: null,
  fileMg: 0,
  extsnNm: null,
  bucketName: null,
  objectName: null,
});
const btnFcltyOfslRgst_click = () => {
  fcltyOfslFileUpldRef.value.upload_click()
}

const fcltyOfslFileUpld_change = async (fileInfo) => {
  fcltyOfslFile.orgnFlnm = fileInfo.orgnFlnm;
  fcltyOfslFile.strePth = fileInfo.strePth;
  fcltyOfslFile.flnm = fileInfo.flnm;
  fcltyOfslFile.fileMg = fileInfo.fileMg;
  fcltyOfslFile.extsnNm = fileInfo.extsnNm;
  fcltyOfslFile.bucketName = fileInfo.bucketName;
  fcltyOfslFile.objectName = fileInfo.objectName;

  const url = await $file.ncp.tmp.getDwldUrl(fcltyOfslFile.objectName);
  fcltyOfslSrc.value = url;
}

const btnSmplPrsnt_click = async () => {
  let prsntAt = true;
  const {signcertDer, signpriKey, certpwd, certname} = cprCrct;
  const isCprCrct = signcertDer && signpriKey && certpwd && certname;
  if (!isCprCrct) {
    prsntAt = false;
  }

  const popupOpts = {
    header: '간편제출',
    contentStyle: {
      'width': '700px',
    }
  }

  const emits = {'rgst': cprCrctRgst};
  const props = {prsntAt};
  $popup.show(StmnSmplPrsntCnfm, popupOpts, props, emits);
};

const cprCrctRgst = async () => {
  initSmartaib4pc(fcltySn.value, {suc: cprCrctSuc, err: cprCrctErr});
}

const btnPdfPrsnt_click = async () => {
  let prsntAt = true;
  if (pdfFiles.value.length === 0) {
    prsntAt = false;
  }

  const popupOpts = {
    header: '직접제출',
    contentStyle: {
      'width': '700px',
    }
  }

  const emits = {'rgst': pdfChoc};
  const props = {prsntAt};
  $popup.show(StmnPdfPrsntCnfm, popupOpts, props, emits);
};

const pdfChoc = async () => {
  const popupOpts = {
    header: '직접제출',
    contentStyle: {
      'width': '700px',
    }
  }

  const emits = {'rgst': pdfRgst};
  const props = {'pdfFiles': pdfFiles.value};
  $popup.show(StmnPdfUpload, popupOpts, props, emits);
}

const pdfRgst = async (data) => {
  pdfFiles.value = data;
}

const cprCrct = reactive({
  signcertDer: '',
  signpriKey: '',
  certpwd: '',
  certname: '',
});

const cprCrctSuc = async (result) => {
  try {
    $loading.on();

    const {SIGNCERT_DER, SIGNPRI_KEY, CERTPWD, CERTNAME} = result;
    cprCrct.certname = CERTNAME;
    cprCrct.certpwd = CERTPWD;
    cprCrct.signcertDer = SIGNCERT_DER;
    cprCrct.signpriKey = SIGNPRI_KEY;
  } catch (e) {
    await $cmmn.errorMsg(e);
  } finally {
    $loading.off();
  }
}

const cprCrctErr = async (errCode, errMsg) => {
  await $alert('인증서 등록에 실패했습니다. 다시 시도해주세요.\n\n' + '에러메시지: [' + errCode + '] ' + errMsg);
}

const valid = () => {
  let isValid = true;
  let msg = '';

  if (isValid && rpstvIirno.value.length != 13) {
    isValid = false;
    msg = '대표자 주민번호를 입력해주세요.';
  }

  if (isValid && !$valid.iirno(rpstvIirno.value)) {
    isValid = false;
    msg = '대표자 주민번호가 올바르지 않습니다. 다시 확인해주세요.';
  }

  if (isValid && !opbzDe.value) {
    isValid = false;
    msg = '개업일을 입력해주세요.';
  }

  if (isValid && !chrgrNm.value) {
    isValid = false;
    msg = '담당자명을 입력해주세요.';
  }

  if (isValid && chrgrCtpc.value.length < 12) {
    isValid = false;
    msg = '담당자 연락처를 입력해주세요.';
  }

  if (isValid && !$valid.mbpnTlno(chrgrCtpc.value)) {
      isValid = false;
      msg = '정상적인 핸드폰 번호 형식으로 입력해주세요.';
  }

  if (isValid && !rtunBnkCd.value) {
    isValid = false;
    msg = '환급은행을 선택해주세요.';
  }

  if (isValid && !rtunDpstr.value) {
    isValid = false;
    msg = '예금주를 입력해주세요.';
  }

  if (isValid && !rtunCcno.value) {
    isValid = false;
    msg = '환급계좌번호를 입력해주세요.';
  }

  if (isValid && !fcltyOfslSrc.value) {
    isValid = false;
    msg = '시설 직인을 등록해주세요.';
  }

  return {isValid, msg};
}

const getRqtParams = () => {
  const {signcertDer, signpriKey, certpwd, certname} = cprCrct;
  return {
    fcltySn: fcltySn.value,
    mberSn: $mber.mberSn,
    rpstvIirno: rpstvIirno.value,
    opbzDe: opbzDe.value,
    rtunBnkCd: rtunBnkCd.value,
    rtunDpstr: rtunDpstr.value,
    rtunCcno: rtunCcno.value,
    chrgrNm: chrgrNm.value,
    chrgrCtpc: chrgrCtpc.value,
    signcertDer,
    signpriKey,
    certpwd,
    certname,
    fcltyOfslFile,
    pdfFiles: pdfFiles.value,
  }
}

const btnRqt_click = async () => {
  try {
    $loading.on();

    const {isValid, msg} = valid();
    if (!isValid) {
      await $alert(msg);
      return false;
    }

    await stmnAgncyCnsgRqt();
  } catch (e) {
    await $cmmn.errorMsg(e);
  } finally {
    $loading.off();
  }
}

const stmnAgncyCnsgRqt = async () => {
  const params = getRqtParams();
  const {data} = await $axios.post('/api/fclty/stmn-agncy-cnsg-rqt', params);
  const {isSccs, msg, code} = data;

  if (!isSccs) {
    await $alert(msg);
    console.log(code);
    return false;
  }

  openComptPopup(fcltySn.value);

  emits('compt');
  emits('close');
};

const openComptPopup = (fcltySn) => {
  const popupOpts = {
    header: '신고대리 위탁 요청 완료',
    contentStyle: {
      width: '700px',
    }
  };

  const popupProps = { fcltySn };
  const popupEmits = {'compt': btnCancl_click};
  $popup.show(StmnAgncyCnsgRqtCompt, popupOpts, popupProps, popupEmits);
}

const emits = defineEmits(['close', 'compt']);
const btnCancl_click = () => {
  emits('close');
}

const init = async () => {
  await loadSmartaib4pcScript();
  const [cds, fclty] = await Promise.all([$cd.getCmmnCds('SYS0086'), $cmmn.fclty.getFcltyByFcltySn(fcltySn.value)]);

  bnks.value = cds;
  rpstvNm.value = fclty.rpstvNm;
}

onMounted(async () => {
  try {
    $loading.on();

    await init();
  } catch (e) {
    await $cmmn.errorMsg(e);
  } finally {
    $loading.off();
  }
})
</script>

<style scoped>
.submit-desc {
  margin: 5px 0;
  margin-bottom: 15px;
  color: #666;
}

.method-item {
  margin-bottom: 10px;
}

.method-item:last-child {
  margin-bottom: 0;
}

.method-label {
  display: inline-block;
  margin-right: 10px;
  font-weight: bold;
}

.method-desc {
  color: #666;
  padding: 10px;
  background: #f5f5f5;
}
</style>
